/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_MY_NEAREST_EVENTS,
  LOAD_MY_NEAREST_EVENTS_SUCCESS,
  LOAD_MY_NEAREST_EVENTS_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  console.log(recordsMetaData, "recordsMetaData")
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//permission list
export function loadMyNearestEvents(searchvalue) {
  return {
    type: LOAD_MY_NEAREST_EVENTS,
    searchvalue,
  }
}
export function loadMyNearestEventsSuccess(my_events) {
  return {
    type: LOAD_MY_NEAREST_EVENTS_SUCCESS,
    my_events,
  }
}
export function loadMyNearestEventsError(error) {
  return {
    type: LOAD_MY_NEAREST_EVENTS_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadMyNearestEvents,
  loadMyNearestEventsSuccess,
  loadMyNearestEventsError,
}

export default actions
